<template>
  <div>
    <h3 v-if="label.length">{{ label }}</h3>

    <div class="row">
      <div class="col-md-12 my-3" v-for="(carriage, idx) in data" :key="idx">
        <div class="row">
          <div class="col-md-6">
            <IcFormRowWrapper
          rowElement="IcFormRow"
          id="type"
          name="carriage.type"
          :label="$t('label_carriage_type')"
          :aria="$t('required')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcSelect
              id="type"
              :values="carriageTypes(idx)"
              v-model="data[idx].type"
              @input="emitInput(data,validator)"
            />
          </template>
        </IcFormRowWrapper>
          </div>
          <div class="col-4" v-if="withCount">
            <IcFormRowWrapper
          rowElement="IcFormRow"
          id="count"
          name="carriage.count"
          :aria="$t('aria_required')"
          :label="$t('label_count')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="count" type="number" v-model="data[idx].count" @input="emitInput(data,validator)" maxlength="20" :readonly="data[idx].type === 'Wagon konferencyjny 507' || data[idx].type === 'Wagon konferencyjny 508'"></IcInput>
          </template>
        </IcFormRowWrapper>            
          </div>
          <div class="col-2 d-flex align-items-center justify-content-start">
            <button class="btn btn-danger pull-right" @click.prevent="removeCarriage(idx)"
              v-if="idx > 0 || data.length > 1">
              <i class="gg-remove"></i>
              <span class="sr-only">Usuń wagon</span>
            </button>
          </div>

        </div>
      </div>
    </div>

    <button class="btn btn-toggle btn-block btn-secondary" @click.prevent="addCarriage()" v-if="this.data.length < 6 && this.maxCarriages > this.data.length">
      
      Dodaj wagon</button>
  </div>
</template>

<script>
import IcFormRow from "@/components/ic-common/form/helpers/FormRow.vue";
import IcFormRowHorizontal2 from "@/components/ic-common/form/helpers/FormRowHorizontal2.vue";
import IcSelect from "@/components/ic-common/form/controls/Select.vue";
import IcInput from "@/components/ic-common/form/controls/Input.vue";
import IcTextarea from "@/components/ic-common/form/controls/Textarea.vue";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox.vue";
import { Carriage } from "../Model/Carriage";
import { emitInput } from "./mixins";

export default {
  name: "IcFormCarriage",
  props: {
    value: {
      type: [Object,Array],
    },
    label: {
      type: String,
      default: ""
    },    
    withCount: {
      type: [Boolean],
      default: true
    },    
    maxCarriages: {
      type: [Number],
      default: 2
    },    
  },
  data() {
    return {
      data: [],
      count: "",
    };
  },
  watch: {
    value: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.data = this.value;
      }
    },
  },
  computed: {
 
  },
  mounted() {
    if (this.data.length === 0) {
      this.addItem();
    }
  },

  methods: {
    carriageTypes(idx){
      var opts = [
          {value:"Wagon przedziałowy  klasa 1", "name":"Wagon przedziałowy  klasa 1"},
          {value:"Wagon przedziałowy  klasa 2", "name":"Wagon przedziałowy  klasa 2"},
          {value:"Wagon bezprzedziałowy klasa 1", "name":"Wagon bezprzedziałowy klasa 1"},
          {value:"Wagon bezprzedziałowy klasa 2", "name":"Wagon bezprzedziałowy klasa 2"},
          {value:"Wagon konferencyjny 507", "name":"Wagon konferencyjny 507"},
          {value:"Wagon konferencyjny 508", "name":"Wagon konferencyjny 508"},
          {value:"Wagon sypialny", "name":"Wagon sypialny"},
          {value:"Wagon restauracyjny", "name":"Wagon restauracyjny"}
        ];
        if(this.znajdzIndeks(this.data,'Wagon konferencyjny 507') != -1 && this.znajdzIndeks(this.data,'Wagon konferencyjny 507') != idx)
           opts = this.filtrujPoValue(opts,"Wagon konferencyjny 507");
        if(this.znajdzIndeks(this.data,'Wagon konferencyjny 508') != -1 && this.znajdzIndeks(this.data,'Wagon konferencyjny 508') != idx)
        opts = this.filtrujPoValue(opts,"Wagon konferencyjny 508");
        
        return opts;
      },      
     znajdzIndeks(tablica, szukanaWartosc) {
    // Użyj pętli for do iteracji przez elementy tablicy
    for (var i = 0; i < tablica.length; i++) {
        // Sprawdź, czy wartość w danym polu obiektu jest równa szukanej wartości
        if (tablica[i]['type'] === szukanaWartosc) {
            // Jeśli warunek jest spełniony, zwróć indeks obiektu
            return i;
        }
    }
    // Jeśli nie znaleziono, zwróć -1
    return -1;
    }   ,   
    filtrujPoValue(tablica, szukaneValue) {
    // Użyj metody filter do utworzenia nowej tablicy z obiektami, które pasują do warunku
    var wynikowaTablica = tablica.filter(function(obiekt) {
        // Sprawdź, czy Value obiektu jest równe szukanemu Value
        return obiekt.value !== szukaneValue;
    });

    return wynikowaTablica;
    },
    emitInput,
    addCarriage() {
      if (this.data.length < 6 && this.data.length < this.maxCarriages) {
        this.addItem();
      }
    },
    removeCarriage(idx) {
      this.data.splice(idx, 1);
    },
    onUpdateCarriage(idx) {

    },

    addItem() {
      this.data.push(new Carriage());
    }
  },
  components: {
    IcFormRow,
    IcFormRowHorizontal2,
    IcSelect,
    IcInput,
    IcTextarea,
    IcCheckbox
  }
};
</script>

<style></style>
